// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3Fbt_","row":"Node_row__ki3RU","label":"Node_label__1mNPa","footer":"Node_footer__1w97t"};